module.exports = __webpack_public_path__ + "static/media/bg-banner-top.9d9ac2f2.png";